import { captureException } from "@sentry/vue";
import { Ref } from "vue";

export interface MapStyle {
	id: string;
	label: string;
}
export const mapboxStyles: MapStyle[] = [
	{
		id: "streets-v12",
		label: "Standard",
	},
	{
		id: "satellite-streets-v12",
		label: "Satellite",
	},
	{
		id: "outdoors-v12",
		label: "Outdoors",
	},
	{
		id: "navigation-day-v1",
		label: "Navigation",
	},
	{
		id: "dark-v11",
		label: "Night",
	},
] as const;

export function getStylePath(id: string) {
	return `mapbox://styles/mapbox/${id}`;
}

export function useMapStyles(map: Ref<mapboxgl.Map | null>) {
	function setMapStyle(styleId: string) {
		if (!map.value) {
			console.error("Map not initialized");
			captureException(new Error("Map not initialized"));
			return;
		}
		map.value.setStyle(getStylePath(styleId));
		savePreferredMapStyle(styleId);
	}

	function savePreferredMapStyle(styleId: string) {
		localStorage.setItem("preferredMapStyle", styleId);
	}

	function getPreferredMapStyle() {
		return localStorage.getItem("preferredMapStyle") ?? mapboxStyles[0].id;
	}

	return { setMapStyle, getPreferredMapStyle };
}
